import { ArrowUpRight, Languages, Menu, X } from 'lucide-react'
import type { RefObject } from 'react'
import { Button } from '../ui/button'

type NavbarBlockProps = {
  brand: string
  links: Array<{ href: string; label: string }>
  cta: string
  localeLabel: string
  localeCode: string
  navigationLabel: string
  mobileNavigationLabel: string
  menuLabel: string
  closeMenuLabel: string
  menuOpen: boolean
  menuButtonRef?: RefObject<HTMLButtonElement | null>
  onToggleLocale: () => void
  onToggleMenu: () => void
  onCloseMenu: () => void
  onCtaClick?: () => void
}

export function NavbarBlock({ brand, links, cta, localeLabel, localeCode, navigationLabel, mobileNavigationLabel, menuLabel, closeMenuLabel, menuOpen, menuButtonRef, onToggleLocale, onToggleMenu, onCloseMenu, onCtaClick }: NavbarBlockProps) {
  return <header className="site-header" data-od-id="site-header">
    <div className="container header-inner">
      <a className="brand" href="#top" data-od-id="brand-link">{brand}</a>
      <nav className="nav" aria-label={navigationLabel}>{links.map((link) => <a href={link.href} key={link.href}>{link.label}</a>)}</nav>
      <div className="header-actions">
        <button className="language-toggle" type="button" onClick={onToggleLocale} aria-label={`${localeCode} ${localeLabel}`}><Languages aria-hidden="true" /><span>{localeCode}</span></button>
        <Button asChild className="header-cta"><a href="#contact" onClick={onCtaClick}>{cta}<ArrowUpRight aria-hidden="true" /></a></Button>
        <button ref={menuButtonRef} className="menu-toggle" type="button" aria-expanded={menuOpen} aria-controls="mobile-menu" aria-label={menuOpen ? closeMenuLabel : menuLabel} onClick={onToggleMenu}>{menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}</button>
      </div>
    </div>
    <nav id="mobile-menu" className={`mobile-menu ${menuOpen ? 'is-open' : ''}`} aria-label={mobileNavigationLabel} hidden={!menuOpen}>
      {links.map((link) => <a href={link.href} onClick={onCloseMenu} key={link.href}>{link.label}</a>)}
      <a className="mobile-menu-cta" href="#contact" onClick={onCloseMenu}>{cta}<ArrowUpRight aria-hidden="true" /></a>
    </nav>
  </header>
}
